import React from 'react'
import SearchIcon from '@mui/icons-material/Search';
import TextField from "@mui/material/TextField";
import { makeStyles } from '@mui/styles';
import InputAdornment from '@mui/material/InputAdornment';

//* node modules
import debounce from 'lodash.debounce';

const useStyles = makeStyles((theme) => ({
    textField: {
        background: '#FFFFFF',
        border: '1px solid #D0D5DD !important',
        boxSizing: 'border-box',
        boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
        borderRadius: '0.8rem',
        padding: "0 !important",
        width:"100%"
    },
    input: {
        "&.Mui-focused": {
            '& .MuiOutlinedInput-notchedOutline': {
                border: '1px solid #D0D5DD !important'
            }
        },
        "&:hover": {
            '& .MuiOutlinedInput-notchedOutline': {
                border: '1px solid #D0D5DD !important'
            }
        },
        '& input': {
            padding: '1rem 1.4rem !important',
            lineHeight: '2.4rem',
            fontSize: '1.6rem',
            paddingLeft: "0 !important"
        }
    }
}));

export default function SearchBar({ placeholder, search }) {

    const classList = useStyles();

    const debouncedFetchData = debounce((e) => {
        search(e.target.value);
    }, 500);

    return (
        <TextField className={classList.textField}
        tabIndex="0"
            id="input-with-icon-textfield"
            placeholder={placeholder} 
            onChange={debouncedFetchData}
            InputProps={{
                className: classList.input,
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon style={{ color: "#667085" }} />
                    </InputAdornment>
                ),
            }}
            variant="outlined"
        />
    )
}
